import { Link } from "react-router-dom";


const Awardsrewards = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
         
          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Awards and Rewards</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Awards and Rewards Details</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">


                      {/* =======================Mobile start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Mobile</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              View Here
                            </Link>

                            
                          </div>
                        </div>
                      </div>

                      {/* =======================Mobile end================= */}

                      {/* =======================Television start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Television</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              View Here
                            </Link>

                           
                          </div>
                        </div>
                      </div>

                      {/* =======================Television end================= */}

                      {/* =======================Thailand start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Thailand</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>

                            
                          </div>
                        </div>
                      </div>

                      {/* =======================Thailand end================= */}

                      {/* =======================Bike start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Bike</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>

                            
                          </div>
                        </div>
                      </div>

                      {/* =======================Bike end================= */}

                      {/* =======================Car start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Car</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>

                            
                          </div>
                        </div>
                      </div>

                      {/* =======================Car end================= */}

                      {/* =======================House start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">House</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>

                            
                          </div>
                        </div>
                      </div>

                      {/* =======================House end================= */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Awardsrewards;
